import { RouteLocationNamedRaw } from 'vue-router';
import { Routing } from '../router/Routing';
import { IEmbeddedState } from './IEmbeddedState';
import { ConvergingTask } from '../platform/ConvergingTask';
import { NavigationInitiatedEvent } from './events/NavigationInitiatedEvent';
import { EventAggregationService } from '@/platform/EventAggregationService';

export class UrlNavigation extends ConvergingTask<RouteLocationNamedRaw | null, IEmbeddedState> {
	private readonly routing: Routing;
	private readonly eventAggregationService: EventAggregationService;

	public constructor(routing: Routing, eventAggregationService: EventAggregationService) {
		super();
		this.routing = routing;
		this.eventAggregationService = eventAggregationService;
	}

	public async navigateFrom(embeddedState: IEmbeddedState): Promise<void> {
		await this.execute(embeddedState);
	}

	protected override beforeEachRun(_runPromise: Promise<unknown>, embeddedState: IEmbeddedState): void {
		this.eventAggregationService.publish(new NavigationInitiatedEvent(_runPromise, embeddedState));
	}

	protected override async run(embeddedState: IEmbeddedState): Promise<RouteLocationNamedRaw | null> {
		return await this.routing.toNavigationTarget(embeddedState);
	}

	protected override async commit(result: RouteLocationNamedRaw | null): Promise<void> {
		if (result !== null) {
			await this.routing.navigateTo(result);
		}
	}

	protected override queued(): boolean {
		return false;
	}
}
